import { render, staticRenderFns } from "./vAudio.vue?vue&type=template&id=384f1f2e&"
import script from "./vAudio.vue?vue&type=script&lang=js&"
export * from "./vAudio.vue?vue&type=script&lang=js&"
import style0 from "./vAudio.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports